import gql from "graphql-tag";

const fragmentName = "ProductListProductDetail";

const fragment = `
  fragment ${fragmentName} on ProductListProduct {
    id
    code
    name
    slug
    logo
    partner
    redirect
    enabled
    active
    conversion
    productAttributes {
      descriptor
      value
      level
      enabled
      isAccurate
      featured
      extraDescription
      entity {
        icon
        label
        config
        dataType
        code
        extraDescription
        config
      }
    }
    division {
      slug
      logo
      name
    }
    reviews {
      total
      averageValue
      totalByValue {
        value
        total
      }
      userReviews {
        id
        comment
        value
        userId
        userName
        createdAt
      }
    }
  }
`;

export const getProduct = gql`
  ${fragment}
  query Product(
    $businessUnit: String!
    $productSlug: String!
    $divisionSlug: String!
  ) {
    productDetailsBySlug(
      businessUnit: $businessUnit
      productSlug: $productSlug
      divisionSlug: $divisionSlug
    ) {
      ...${fragmentName}
    }
  }
`;
